module.exports = __webpack_public_path__ + "static/p4-206c57d4910125760a6ed32d2bf2735d.png";